module.exports = __webpack_public_path__ + "img/man.9bc4ed14.svg";